import { Inject, Injectable, OnInit } from "@angular/core";
import { Constant } from "@shared/utilities/constant";
import { Observable, from, of } from "rxjs";
import { CoreConstant } from '@app/core/utilities/core.constant';
import { Constants as UrlConstants } from './constants';
import { catchError, map } from "rxjs/operators";
import { environment } from 'src/environments/environment';
import { AppConfig } from "@shared/models/app-config.model";

//set the Client Id based on the the URL
@Injectable()
export class ClientService {

    public sessionStoreClientCode(): Observable<any> {
      let clientCodeAPI = '';
      clientCodeAPI = sessionStorage.getItem(Constant.clientCode);
      return of(clientCodeAPI);
    }

    public getClientCodeFromHost(): string {
        let clientCode = "";        
        let hostname = window.location.host;

        // this below logic for localhost development time defualt client as AIPINTERNAL
        if (hostname.indexOf(':') !== -1) {
          let hostWithoutPort = hostname.split(':');

            if (hostWithoutPort.length > 0) {

                if (hostWithoutPort[0].toLowerCase() == Constant.localhost) {
                    clientCode = Constant.productApp.toLowerCase();
                }
            }
            return clientCode;        }

        // this below logic for set client code on runt time for hosted server  
        const segments = hostname.split('.');
        if (segments.length > 0) {
            //check for if host first part conatins '_' as special character
            if (segments[0].indexOf('-') !== -1) {
                clientCode = segments[0].split('-')[0];
            } else {
                clientCode = segments[0];
            }
        }

        return clientCode;
    }

    public getDomainFromHost(): string {
      const domain = sessionStorage.getItem(Constant.host);
      return domain;
    }

    // convert object key to lowercase
    transformKeysToLowerCase(obj: any): any {
        if (!obj || typeof obj !== 'object') {
          return obj;
        }
    
        const newObj = {};
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                newObj[key.toLowerCase()] = this.transformKeysToLowerCase(obj[key]);
            }
        }
        return newObj;
    }

    manipulatedClientCode() {
        var clientId;
        var domain;
        const url = window.location.href;
        domain = window.location.protocol + "//" + window.location.host;
        
        const isAlreadyLoggedIn = localStorage.getItem(CoreConstant.authServiceConstants.isLoggedIn);
    
        const match = url.indexOf(Constant.userPageUrl) > -1;
        
        // If user is already logged in and user segments avaialble in the current URL
    
        if (match && (isAlreadyLoggedIn || isAlreadyLoggedIn === "true")) {
    
            clientId = sessionStorage.getItem(Constant.ClientId);
            domain = sessionStorage.getItem(Constant.host);
    
            if (clientId === undefined || clientId === null || clientId === "" || clientId === "null") { // if  client Code not avaialable will get from URL HOST segments
    
              clientId = this.getClientCodeFromHost();
      
              sessionStorage.setItem(Constant.ClientId , clientId);      
              
      
            }
    
            if(domain == null || domain == "" ||  domain == "null") {
              domain = window.location.protocol + "//" + window.location.host;
              sessionStorage.setItem(Constant.host, domain);
            }
        
        } else if(match && (!isAlreadyLoggedIn)) {  // If user is not logged in and user segments avaialble in the current URL
    
            clientId = sessionStorage.getItem(Constant.ClientId);
    
            if (clientId == null || clientId == "" || clientId === "null") { // if  client Code not avaialable will get from URL HOST segments
    
                clientId = this.getClientCodeFromHost();
        
                sessionStorage.setItem(Constant.ClientId , clientId);
                sessionStorage.setItem(Constant.host, domain);    
    
            }
    
    
    
        } else {
    
          // If user is not logged in and login/register/caregiverregister segments avaialble in the current URL
    
            if ((url.indexOf(Constant.loginPageUrl) > -1) 
                 || (url.indexOf(Constant.registerPageUrl) > -1) 
                 || (url.indexOf(Constant.caregiverregisterPageUrl) > -1)) {
    
                clientId = sessionStorage.getItem(Constant.ClientId);
                domain = sessionStorage.getItem(Constant.host);
    
                if (clientId == null || clientId == "" || clientId == "null" ) {
    
                  clientId = this.getClientCodeFromHost();
    
                }

                if(domain == null || domain == "" ||  domain == "null") {
                  domain = window.location.protocol + "//" + window.location.host;
                }      
    
                sessionStorage.setItem(Constant.ClientId , clientId);
                sessionStorage.setItem(Constant.host, domain);
    
            } else { // If Unsubscribe or landing segments avaialble in the current URL 
        
              if (url.indexOf(Constant.unsubscribePageUrl) > -1) { // unsubscribe page segment

                clientId = Constant.unsubscribePageUrl;

              } else {

                clientId = url.substring(url.lastIndexOf('/') + 1);

                if (clientId === Constant.landingPageUrl) { // landing page segment
                
                    clientId = clientId ? clientId === Constant.landingPageUrl ? Constant.productApp.toLocaleLowerCase() : clientId.toLowerCase() : Constant.productApp.toLocaleLowerCase();
                
                } 

              }
                sessionStorage.setItem(Constant.ClientId , clientId);
                sessionStorage.setItem(Constant.host, domain);    
    
            }           
           
        } 

        return clientId; 
    }

    fetchData(url: string): Observable<any> {
      // Wrap the fetch call in an Observable using `from` operator
      return from(
        fetch(url)
          .then((response) => response.text())
          .catch((error) => {
            throw new Error('Fetch failed: ' + error.message);
          })
      ).pipe(
        // Handle the data transformation
        map((data) => {
          return data; // Transform the data as needed
        }),
        catchError((error) => {
          // Handle any errors
          console.error('Error occurred:', error);
          throw error;
        })
      );
    }

   
}
